export default __webpack_public_path__ + "static/media/bedroom3.cfd5e7b7.webp";